import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Card,
  CardBody,
  Row,
  CardImg,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  dAPI_Delete_Ingetration,
  putAPI_Update_OnOff,
} from '../../../../../../constants/APIs';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import { BrowserRouter as Router, NavLink } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import GMailIcon from '../../../../../../assets/gmail.png';
export default function GmailIntegrationThumb({
  integration,
  allProperties,
  LoadIntegrations,
  title,
}) {
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [formatedProperties, setFormatedProperties] = useState('');
  const [moreProperties, setMoreProperties] = useState('');
  const [checkedPrimarySmall, setCheckedPrimarySmall] = useState(
    !integration?.disabled
  );
  useEffect(() => {
    const result = integration.properties?.map((id) => {
      return allProperties.find((elem) => elem.id === id);
    });
    if (result?.length > 2) {
      const filterResults = result?.slice(0, 2);
      setFormatedProperties(filterResults.map((elem) => elem?.name).join(', '));
      setMoreProperties('and ' + (result.length - filterResults.length) + ' more');
    } else {
      const filterResults = result?.filter((elem) => elem !== undefined);
      setFormatedProperties(filterResults?.map((elem) => elem?.name).join(', '));
    }
  }, [integration, allProperties]);

  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const handleDelete = () => {
    AxiosAPI({
      method: 'delete',
      url: `${dAPI_Delete_Ingetration}/${integration.id}/?group_id=${getGroupID()}`,
    }).then((res) => {
      toggle();
      LoadIntegrations();
    });
  };
  const handleOnOff = (onoff) => {
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_OnOff}/${integration.id}/?group_id=${getGroupID()}`,
      data: { disabled: onoff },
    }).then((res) => {
      LoadIntegrations();
    });
  };

  const handleSwitchChange = (value) => {
    setCheckedPrimarySmall(value);
    handleOnOff(!value);
  };

  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This integration will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button color="danger" onClick={() => handleDelete()} size="xs">
                    Delete
                  </Button>
                  <Button className="ml-2" color="dark" outline size="xs" onClick={toggle}>
                    Cancel
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  return (
    <Fragment>
      {integration ? (
        <Colxx md="6" sm="6" lg="3" xxs="12" className="mb-3">
          <Card className="d-flex flex-row" style={{ height: '215px' }}>
            <div>
              <h3 className="integrationChannel">
                <img src={GMailIcon} alt="gmail" style={{ width: '30px', height: '30px' }} />
              </h3>
              <Switch
                className="agentswitch custom-switch-primary custom-switch-small integrationremove"
                checked={checkedPrimarySmall}
                onChange={(primary) => handleSwitchChange(primary)}
              />
            </div>
            <CardBody>
              <Row>
                <Colxx xxs="12" className="mb-3">
                  <NavLink
                    to={{
                      pathname: '/app/pages/gmail-integrationdetail/' + integration.id,
                    }}
                    key={integration.id}
                  >
                    <div className="text-center mt-3">
                      <h5>{title || 'Email Automation with Gmail'}</h5>
                      <div className="mb-1">{integration ? integration.name : null}</div>
                      <div className="mb-2">
                        <b>{formatedProperties} </b>
                        <b>{moreProperties}</b>
                      </div>
                    </div>
                  </NavLink>
                </Colxx>
              </Row>
            </CardBody>
            <div className='integrationdelete'>
              <FontAwesomeIcon
                icon={faTrashAlt}
                style={{ color: 'var(--theme-color-1)' }}
                cursor="pointer"
                onClick={toggle}
              />
            </div>
          </Card>
        </Colxx>
      ) : null}
      {generateDeleteButton()}
    </Fragment>
  );
}
